import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect, useRef} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import { Search } from "@mui/icons-material";
import { IconButton} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

  const RedButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: "#ff0000",
    '&:hover': {
      backgroundColor: "#8b0000",
    },
  }));

  export default function NewKlienPopUp({handleClose, handleCloseNoTelp,handleCloseNewCompany,selectNamaPerusahaan, setcompanyID, companies, handleCompany2, setCompanies, closechangePerusahaanPopUPOpen, setContractData, contractData}){
    const [namaPerusahaan,setNamaPerusahaan] = useState("")
    const [error,setError] = useState("")

    const [industri,setIndustri] = useState(["..."])


    const [ktp,setKTP] = useState("")
    const [npwp,setNPWP] = useState("")
    const [email,setEmail] = useState([""])
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredCompany, setIsHoveredCompany] = useState(false);
    const [tipePerusahaan, setTipePerusahaan] = useState("");
    
    const handleNamaPerusahaan = (event) => {
      const value = event.target.value;
      let updatedValue = value;
      let updatedTipePerusahaan = tipePerusahaan;
    
      const regex = /^(pt|cv)\.\s+/i;
    
      if (value.match(regex)) {
        updatedValue = value.replace(regex, "");
        updatedTipePerusahaan = value.match(/^(pt|cv)/i)[0].toUpperCase();
      }
    
      setNamaPerusahaan(updatedValue);
      setTipePerusahaan(updatedTipePerusahaan);
      event.target.value = updatedValue; // Update the input field value
      
    };
    
    
    
    
    
    
    const handleIndustri = (event) => {
        const values =[...industri];
        values[0] = event.target.value;
        setIndustri(values);
    }
    const handleCompany = (post, idid) => {
      console.log(post.namaPerusahaan)
      console.log("idid"+idid)
        const values =[...companies];
        values[0].NamaPT = post.namaPerusahaan;
        values[0].CompanyID= idid;
        setCompanies(values);
    }
    const handleKTP = (event) => {
        setKTP(event.target.value);
    }
    const handleNPWP = (event) => {
      let value = event.target.value;
value = value.replace(/\D/g, ""); // Remove any non digit character
value = value.replace(/^(\d{2})(\d)/, "$1.$2");
value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})-(\d{1})(\d)/, "$1.$2.$3-$4.$5");
value = value.slice(0,20); // Limit length to 15 digits and 5 special characters (20 in total)
      setNPWP(value);
    };
    const handleEmail = (event) => {
        const values =[...email];
        values[0] = event.target.value;
        setEmail(values);
        console.log(email);
    }

  async function saveCompany(e) {
      setLoading(true)
      if (tipePerusahaan === "" || namaPerusahaan === "" || industri[0] === "" || npwp === "") {
        console.log("gagal ada data kurang");
      } else {
        const regex = /^(PT\.|CV\.)\s+/i;
        const formattedNamaPerusahaan = namaPerusahaan.replace(regex, "");
        
        console.log(industri);
        console.log("sending data to backend");

        // Assuming that fileKTP and fileNPWP are your file objects
        const filesToUpload = [
          { file: fileNIB, name: 'fileNIB' },
          { file: fileNPWP, name: 'fileNPWP' },
          { file: fileAKTE, name: 'fileAkte' },
        ];
        if(fileNPWP !== null){

        // Map over the files array and return an array of promises
        const uploadPromises = filesToUpload.map((fileObj) => {
          if (fileObj.file) { // if the file is not null, upload it
            return axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`, {
              params: {
                filename: fileObj.name // send the filename to the server
              }
            })
            .then(response => {
              const uploadUrl = response.data.url;
              const key = response.data.key; // Get the key from the response

              return fetch(uploadUrl, {
                method: 'PUT',
                headers: {
                  'Content-Type': fileObj.file.type
                },
                body: fileObj.file
              }).then(() => key); // After the file is uploaded, return the key
            })
            .catch(error => {
              console.error('Error during file upload:', error);
            });
          }

          // if the file is null, return a resolved promise with value null
          return Promise.resolve(null);
        });

        Promise.all(uploadPromises)
            .then(fileKeys => {
              const [nibKey, npwpKey, akteKey] = fileKeys; // Extract keys from the resolved values array


        axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveCompanyQuick`, {
            tipePerusahaan,
            namaPerusahaan: formattedNamaPerusahaan,
            industri,
            npwp,
            noNib,
            akte,
            nibKey,
            npwpKey,
            akteKey,
          })
          .then((response) => {
            console.log(namaPerusahaan)
            console.log(response.data._id)
            const post = { namaPerusahaan: formattedNamaPerusahaan };
            const idid = response.data._id;
            setContractData({...contractData, CompanyName: namaPerusahaan, CompanyID: idid});
            closechangePerusahaanPopUPOpen()
          })
          .catch((error) => {
            console.log(error.message);
            setError(error.response.data.message)
          });
        }).catch(error => {
          console.error("Error during file upload:", error);
        });
        }else{setError("Harus Upload NPWP PT")}}
      setLoading(false)
      handleCloseNewCompany()
      handleCloseNoTelp()
    }
    
    
    const [loading, setLoading] = useState(false); // Define loading state
    const handleMouseEnter = () => {
        setIsHovered(true);
      };
    
      const handleMouseLeave = () => {
        setIsHovered(false);
      };
    

      const handleMouseEnterCompany = () => {
        setIsHoveredCompany(true);
      };
      const [noNib,setNoNIB]=useState()
      const [akte, setAkte]=useState()
      const handleMouseLeaveCompany = () => {
        setIsHoveredCompany(false);
      };
    
      const selectTipePerusahaan = (event) => {
        setTipePerusahaan(event.target.value)
      }

      const handleIconClickCompany = () => {
        // handle search logic here
        console.log("Search clicked");
      };

      const styles = {
        container: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          borderRadius: "4px",
          position: "relative",
        },
        text: {
          color: "rgba(0, 0, 0, 1)",
          visibility: "visible",
        },
        iconButton: {
          color: "#fff",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          visibility: "hidden",
          zIndex: 1,
        },
      };
      const [openNoTelp, setOpenNoTelp] = useState(false);

      const newNoTelp = () => {
        console.log("here")
        setOpenNoTelp(true);
    };
  //NPWP File Upload Starts Here
  const [uploadedNPWPStat, setUploadedNPWPStat] = useState(false);
  const [fileNPWP, setNPWPFile] = useState(null);
  const [npwpfileName, setNPWPFileName] = useState("");
const handleNPWPFileChange = (event) => {
  setNPWPFile(event.target.files[0]);
  setNPWPFileName(event.target.files[0].name);
  setUploadedNPWPStat(true);
};

const clearnpwpFile = (event)=>{
  setNPWPFile(null);
  setNPWPFileName("");
  setUploadedNPWPStat(false);
}

const handleNPWPUploadButtonClick = () => {
  fileInput.current.click();
};
const fileInput = useRef(null);
//NPWP File Upload Ends Here
//NIB File Upload Starts Here
const [uploadedNIBStat, setUploadedNIBStat] = useState(false);
const [fileNIB, setNIBFile] = useState(null);
const [nibfileName, setNIBFileName] = useState("");
const handleNIBFileChange = (event) => {
setNIBFile(event.target.files[0]);
setNIBFileName(event.target.files[0].name);
setUploadedNIBStat(true);
};

const clearnibFile = (event)=>{
setNIBFile(null);
setNIBFileName("");
setUploadedNIBStat(false);
}

const handleNIBUploadButtonClick = () => {
fileInputNIB.current.click();
};
const fileInputNIB = useRef(null);
//NIB File Upload Ends Here
//AKRE File Upload Starts Here
const [uploadedAKTEStat, setUploadedAKTEStat] = useState(false);
const [fileAKTE, setAKTEFile] = useState(null);
const [AKTEfileName, setAKTEFileName] = useState("");
const handleAKTEFileChange = (event) => {
setAKTEFile(event.target.files[0]);
setAKTEFileName(event.target.files[0].name);
setUploadedAKTEStat(true);
};

const clearAKTEFile = (event)=>{
setAKTEFile(null);
setAKTEFileName("");
setUploadedAKTEStat(false);
}

const handleAKTEUploadButtonClick = () => {
fileInputAKTE.current.click();
};
const fileInputAKTE = useRef(null);
//AKTE File Upload Ends Here

        
    return <Grid sx={{p:5}}>
              <Dialog open={loading} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                {error && <div className="error_text">{error}</div>}
            <Grid container>
                <Grid sm={5}> 
                    <p>Tipe:</p>
                </Grid>
                <Grid sm={7}>
                  <Select  fullWidth value={tipePerusahaan} onChange={event => selectTipePerusahaan(event)}><MenuItem value="PT">PT.</MenuItem><MenuItem value="CV">CV.</MenuItem><MenuItem value="Yayasan">Yayasan</MenuItem><MenuItem value="Koperasi">Koperasi</MenuItem><MenuItem value="Law Firm">Law Firm</MenuItem></Select>
                </Grid>
            </Grid>
            <Grid container sx={{mt:5}}>
                <Grid sm={5}> 
                    <p>Nama Perusahaan:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField onChange={event => handleNamaPerusahaan(event)}></TextField>
                </Grid>
            </Grid>
            <Grid container sx={{mt:2}}>

                <Grid sm={5}> 
                    <p>Industri:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField onChange={event => handleIndustri(event)}></TextField>
                </Grid>
            </Grid>
            <Divider style={{ height: '1px', backgroundColor:"lightgrey"}} sx={{my:5}} />

            <Grid container sx={{mt:2, mb:5}}>

                <Grid sm={5}> 
                    <p>NPWP PT:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField onChange={event => handleNPWP(event)}></TextField>
                </Grid>
            </Grid>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="file"
                ref={fileInput}
                onChange={handleNPWPFileChange}
                style={{ display: 'none' }}
              />
              <Button
                color={uploadedNPWPStat ? "success" : "primary"}
                variant="contained"
                onClick={handleNPWPUploadButtonClick}
                style={{ marginRight: '8px' }}
              >
                Upload NPWP
              </Button>
              <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {npwpfileName.length > 20 ? `${npwpfileName.slice(0, 17)}...` : npwpfileName}
              </Typography>
              {uploadedNPWPStat && (
                <IconButton size="small" onClick={clearnpwpFile}>
                  <CloseIcon />
                </IconButton>
              )}
            </div>
             <Grid container sx={{mt:2, mb:5}}>

                <Grid sm={5}> 
                    <p>No. Akte:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField value={akte} onChange={event => setAkte(event)}></TextField>
                </Grid>
            </Grid>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="file"
                ref={fileInputAKTE}
                onChange={handleAKTEFileChange}
                style={{ display: 'none' }}
              />
              <Button
                color={uploadedAKTEStat ? "success" : "primary"}
                variant="contained"
                onClick={handleAKTEUploadButtonClick}
                style={{ marginRight: '8px' }}
              >
                Upload NIB/SIUP
              </Button>
              <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {AKTEfileName.length > 20 ? `${AKTEfileName.slice(0, 17)}...` : AKTEfileName}
              </Typography>
              {uploadedAKTEStat && (
                <IconButton size="small" onClick={clearAKTEFile}>
                  <CloseIcon />
                </IconButton>
              )}
            </div>
             <Grid container sx={{mt:2, mb:5}}>

                <Grid sm={5}> 
                    <p>NIB/SIUP:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField value={noNib} onChange={event => setNoNIB(event)}></TextField>
                </Grid>
            </Grid>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="file"
                ref={fileInputNIB}
                onChange={handleNIBFileChange}
                style={{ display: 'none' }}
              />
              <Button
                color={uploadedNIBStat ? "success" : "primary"}
                variant="contained"
                onClick={handleNIBUploadButtonClick}
                style={{ marginRight: '8px' }}
              >
                Upload NIB/SIUP
              </Button>
              <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {nibfileName.length > 20 ? `${nibfileName.slice(0, 17)}...` : nibfileName}
              </Typography>
              {uploadedNIBStat && (
                <IconButton size="small" onClick={clearnibFile}>
                  <CloseIcon />
                </IconButton>
              )}
            </div>
            <Button type="button" variant="contained" onClick={saveCompany}>Save & Use</Button>
            <RedButton type="button" variant="contained" onClick={handleClose}>Cancel</RedButton>

</Grid>    };